const checkFromType = (route) => {
  const q = { ...route.query }
  // 嘉宾id & 活动id & 活动url前缀 & 邀请邮箱
  if (q.gi_guest && q.event_id && q.alias && q.gi_address) return 'guest'
  if (q.event_id) return 'event'
  return 'platform'
}

export  {
  checkFromType
}